import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { UnityComponent } from './unity/unity.component';
import { LoadingComponent } from './loading/loading.component';
import { ButtonRoundComponent } from './button-round/button-round.component';
import { PauseOverlayComponent } from './pause-overlay/pause-overlay.component';
import { SchemaComponent } from './schema/schema.component';
import { ChartComponent } from './chart/chart.component';
import { HomeComponent } from './chart/home/home.component';
import { BarsComponent } from './chart/bars/bars.component';
import { ProductionComponent } from './chart/production/production.component';
import { StorageComponent } from './chart/storage/storage.component';
import { HttpClientModule } from '@angular/common/http';
import { InfopanelComponent } from './infopanel/infopanel.component';
import { VideoComponent } from './video/video.component';
import {VgCoreModule} from 'videogular2/core';
import {VgControlsModule} from 'videogular2/controls';
import {VgOverlayPlayModule} from 'videogular2/overlay-play';
import {VgBufferingModule} from 'videogular2/buffering';

@NgModule({
  declarations: [
    AppComponent,
    UnityComponent,
    LoadingComponent,
    ButtonRoundComponent,
    SchemaComponent,
    ChartComponent,
    HomeComponent,
    BarsComponent,
    ProductionComponent,
    StorageComponent,
    InfopanelComponent,
    VideoComponent,
    PauseOverlayComponent
  ],
  imports: [
    BrowserModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    HttpClientModule,
    NgbModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts